import { render, staticRenderFns } from "./MasterdataBusMatrixCreateModal.vue?vue&type=template&id=2b6334f2"
import script from "./MasterdataBusMatrixCreateModal.vue?vue&type=script&lang=js"
export * from "./MasterdataBusMatrixCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports